import i18next from 'i18next'

export const getUserInitials = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`
  } else if (email) {
    return email.substring(0, 2).toUpperCase()
  } else {
    return '--'
  }
}

export const getUserFullName = (firstName, lastName, email) =>
  firstName && lastName ? `${firstName} ${lastName}` : firstName || lastName || email || i18next.t('Someone')

export const getUserNameOrEmail = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  } else if (firstName || lastName) {
    return firstName || lastName
  } else {
    return email
  }
}

export const getJoinedUserFullName = (firstName, lastName, email) => {
  return getUserFullName(firstName, lastName, email).split(' ').join('_')
}

export const getUserForCSV = user => {
  if (!user) return []

  const userTeams = user.teams ? user.teams.map(t => t).join(':') : ''
  return [
    getUserNameOrEmail(user.firstName, user.lastName, user.email),
    user.email,
    user.currentProTrackName,
    userTeams,
    user.phone,
    user.invitationAccepted,
    user.completedCount || 0,
  ]
}

export const exportUsersAsCSV = data => {
  const records = [
    ['Full Name', 'Email', 'Current ProTrack', 'Teams', 'Phone Number', 'Invitation Accepted', 'Completed'],
    ...data.map(user => getUserForCSV(user)),
  ]

  exportToCsv(`${new Date().toLocaleString().split(', ').join('_')}_export.csv`, records)
}

export const processRow = function (row) {
  let finalVal = ''
  for (let j = 0; j < row.length; j++) {
    let innerValue = row[j] === null ? '' : row[j].toString()
    if (row[j] instanceof Date) {
      innerValue = row[j].toLocaleString()
    }
    let result = innerValue.replace(/"/g, '""')
    if (result.search(/("|,|\n)/g) >= 0) {
      result = '"' + result + '"'
    }
    if (j > 0) {
      finalVal += ','
    }
    finalVal += result
  }
  return finalVal + '\n'
}

function exportToCsv(filename, rows) {
  let csvFile = ''
  for (let i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i])
  }

  const blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', filename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
